import i18n, { ResourceLanguage } from "i18next";
import { initReactI18next } from "react-i18next";
import { de } from "./de";
import { en } from "./en";
import { fr } from "./fr";

export enum AvailableLanguages {
  de = "de",
  en = "en",
  fr = "fr",
}

const resources: { [key in AvailableLanguages]: ResourceLanguage } = {
  de: {
    translation: de,
  },
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "de",
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

// Detect TLD domain ending and switch to language if needed - default is english.
const tld = window.location.hostname.split(".").pop();
if (tld === "de" || tld === "localhost" || tld === "") {
  i18n.changeLanguage("de");
} else if (tld === "fr") {
  i18n.changeLanguage("fr");
}

// Detect language from url if set.
// #app-de, #app-en, #app-fr, etc.
const url = window.location.href;
const urlLang = url.split("#app-").pop();
if (
  urlLang &&
  Object.values(AvailableLanguages).includes(urlLang as AvailableLanguages)
) {
  i18n.changeLanguage(urlLang);
}

export default i18n;
